import { FileText } from 'lucide-react';
import { Card, CardContent, Badge } from '@/components/ui';
import { classificarAtributo } from '@/lib/utils';
import type { ClinusAtributo } from '@/types/api';
import { AtributoDownloadButton } from './AtributoDownloadButton';
import { EmptyState } from '@/components/shared/EmptyState';

interface Props {
  cdAtendimento: number;
  atributos: ClinusAtributo[];
}

export function AtributoList({ cdAtendimento, atributos }: Props) {
  // Filtra atributos com cd_valor > 0 (placeholders vazios)
  const filtered = atributos.filter((a) => a.cd_valor > 0);

  if (filtered.length === 0) {
    return (
      <EmptyState
        title="Sem atributos com conteúdo"
        description="Esta consulta não possui documentos (anamnese, receita, atestado) com conteúdo salvo."
        icon={<FileText className="h-6 w-6" />}
      />
    );
  }

  return (
    <div className="space-y-3" data-testid="atributo-list">
      {filtered.map((atributo) => {
        const tipo = classificarAtributo(atributo);
        return (
          <Card key={atributo.cd_valor} variant={tipo}>
            <CardContent className="p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <Badge variant={tipo} className="capitalize">
                      {tipo}
                    </Badge>
                    <span className="font-medium">{atributo.ds_atributo}</span>
                  </div>
                  <p className="mt-1 text-xs text-muted-foreground">
                    cd_valor: {atributo.cd_valor}
                    {atributo.dt_criacao && ` • criado em ${atributo.dt_criacao}`}
                  </p>
                </div>
                <AtributoDownloadButton
                  cdAtendimento={cdAtendimento}
                  cdValor={atributo.cd_valor}
                  dsAtributo={atributo.ds_atributo}
                />
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
